import { UcoastEl } from '@/scripts/core/UcoastEl'
import { TsDOM as q } from '@/scripts/core/TsDOM'

export class BeforeAfter extends UcoastEl {
	static htmlSelector = 'before-after'
	private rangeInput: HTMLInputElement
	private isDragging = false

	constructor() {
		super()
		this.rangeInput = q.rs<HTMLInputElement>('input[type="range"]', this)
		this.style.setProperty('--clip-position', `${this.rangeInput.value}%`)

		this.rangeInput.addEventListener('input', this.onInput.bind(this))
		this.rangeInput.addEventListener('pointerdown', this.onPointerDown.bind(this))
		window.addEventListener('pointerup', this.onPointerUp.bind(this))
	}

	private onInput() {
		this.style.setProperty('--clip-position', `${this.rangeInput.value}%`)
	}

	private onPointerDown() {
		this.isDragging = true
		this.classList.add('before-after--dragging')
	}

	private onPointerUp() {
		if (!this.isDragging) return
		this.isDragging = false
		this.classList.remove('before-after--dragging')
	}

	disconnectedCallback() {
		super.disconnectedCallback()
		window.removeEventListener('pointerup', this.onPointerUp.bind(this))
	}
}
